import styles from "./task-card.module.css";

export const Title = ({ title }: { title: string }) => {
  return <div className={styles["title"]}>{title}</div>;
};
